import type { EffectsProp } from 'remotion';
import { buildVideoEffects } from './buildVideoEffects';
import type { LutCard } from './lutCards';
import { DEFAULT_VIDEO_EFFECTS } from './types';

type ThumbnailRenderer = {
  draw(source: CanvasImageSource, effects: EffectsProp, width: number, height: number): void;
};

/** Draws one still per LUT card (Original with no effects) through the same
 *  renderer the preview uses, and snapshots each result. A card whose draw
 *  fails is left out, so the carousel falls back to its swatch. */
export function renderLutThumbnails({ source, cards, width, height, renderer, snapshot }: {
  source: CanvasImageSource;
  cards: LutCard[];
  width: number;
  height: number;
  renderer: ThumbnailRenderer;
  snapshot: () => string;
}): Record<string, string> {
  const thumbnails: Record<string, string> = {};
  for (const card of cards) {
    try {
      const effects = card.lut ? buildVideoEffects({ ...DEFAULT_VIDEO_EFFECTS, lut: card.lut }, 1080) : [];
      renderer.draw(source, effects, width, height);
      thumbnails[card.key] = snapshot();
    } catch {
      // Leave this card on its swatch.
    }
  }
  return thumbnails;
}
